/**
 * BfrePrint — impression « BFRE » (besoin en fonds de roulement d'exploitation).
 * Réutilise le COMPOSANT RÉEL de l'écran (FinancialsWorkingCapitalTab,
 * section='treasury') : table 12 mois roulants (composantes → BFRE → liquidités
 * → total) + les 3 rotations (DSO/DIO/DPO : flux, délai, rotation). Unité = celle
 * du hub Liquidités.
 */
import React, { useRef } from 'react';
import FinancialsWorkingCapitalTab from '../FinancialsWorkingCapitalTab';
import { usePersistentValue } from '../../hooks/usePersistentState';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import { useP } from '../../i18n/useP';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

export default function BfrePrint({ activeTenant, year, editedAt, onDataReady }) {
  const p = useP();
  const tenantId = activeTenant?.id;
  const [unit] = usePersistentValue(`liq_unit_${tenantId}`, 'chf');
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('liquidity-bfre'); } };

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={p('Rapport financier')} title={p('BFRE — 12 mois roulants')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <FinancialsWorkingCapitalTab activeTenant={activeTenant} year={year} section="treasury" unit={unit} onReady={ready} />
    </section>
  );
}
